function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "add");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-2",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "iPhone-XS-Copy-3",
  transform: "translate(-35.000000, -220.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(23.000000, 208.000000)"
}, React.createElement("path", {
  d: "M22.5,12.6923077 C17.0763462,12.6923077 12.6923077,17.0763462 12.6923077,22.5 C12.6923077,27.9236538 17.0763462,32.3076923 22.5,32.3076923 C27.9236538,32.3076923 32.3076923,27.9236538 32.3076923,22.5 C32.3076923,17.0763462 27.9236538,12.6923077 22.5,12.6923077 Z M27.4038462,26.0209615 L26.0209615,27.4038462 L22.5,23.8828846 L18.9790385,27.4038462 L17.5961538,26.0209615 L21.1171154,22.5 L17.5961538,18.9790385 L18.9790385,17.5961538 L22.5,21.1171154 L26.0209615,17.5961538 L27.4038462,18.9790385 L23.8828846,22.5 L27.4038462,26.0209615 Z",
  id: "add",
  transform: "translate(22.500000, 22.500000) rotate(45.000000) translate(-22.500000, -22.500000) "
}))));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.dbb54b32.svg";
export { ForwardRef as ReactComponent };